type Props = { className?: string; showSubtitle?: boolean };

export default function Logo({ className = "", showSubtitle = true }: Props) {
  return (
    <span className={`inline-flex items-center gap-2.5 font-semibold tracking-tight ${className}`}>
      <svg
        width="22"
        height="22"
        viewBox="0 0 32 32"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        aria-hidden
      >
        <rect width="32" height="32" rx="6" className="fill-ink-900" />
        <rect x="6"  y="6"  width="9" height="9" rx="2" className="fill-accent-500" />
        <rect x="17" y="6"  width="9" height="9" rx="2" className="fill-ink-700" />
        <rect x="6"  y="17" width="9" height="9" rx="2" className="fill-ink-700" />
        <rect x="17" y="17" width="9" height="9" rx="2" className="fill-accent-500" />
      </svg>
      <span className="flex flex-col leading-none">
        <span className="text-base text-ink-50">
          SV4<span className="text-accent-500">·</span>tech
        </span>
        {showSubtitle && (
          <span className="mt-0.5 text-[0.625rem] font-normal uppercase tracking-[0.18em] text-ink-400">
            by SV4 Ventures
          </span>
        )}
      </span>
    </span>
  );
}
